export const sortByKey = (arr, key) => {
  if (!Array.isArray(arr)) return [];
  return [...arr].sort((a, b) =>
    (a?.[key] || "").localeCompare(
      b?.[key] || "",
      undefined,
      { sensitivity: "base" }
    )
  );
};
